var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#26282F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.906 9.72395L10.3226 11.8228C10.2364 11.9364 10.1206 12 10 12C9.8794 12 9.7636 11.9364 9.67739 11.8228L8.09402 9.72395C8.04953 9.66518 8.01904 9.58988 8.00646 9.50766C7.99388 9.42545 7.99976 9.34005 8.02337 9.26236C8.04698 9.18467 8.08725 9.11822 8.13902 9.07149C8.19079 9.02477 8.25172 8.99988 8.31404 9H11.686C11.7483 8.99988 11.8092 9.02477 11.861 9.07149C11.9128 9.11822 11.953 9.18467 11.9766 9.26236C12.0002 9.34005 12.0061 9.42545 11.9935 9.50766C11.981 9.58988 11.9505 9.66518 11.906 9.72395V9.72395Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.68c92a49a24efa2ef04a5bc7da37568a.svg";
export { ForwardRef as ReactComponent };